// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-5a43cff9] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.icon-vue[data-v-5a43cff9] {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--default-clickable-area);
  min-height: var(--default-clickable-area);
  opacity: 1;
}
.icon-vue.icon-vue--inline[data-v-5a43cff9] {
  display: inline-flex !important;
  min-width: fit-content;
  min-height: fit-content;
  vertical-align: text-bottom;
}
.icon-vue span[data-v-5a43cff9] {
  line-height: 0;
}
.icon-vue[data-v-5a43cff9] svg {
  fill: currentColor;
  width: var(--0c3ef411);
  height: var(--0c3ef411);
  max-width: var(--0c3ef411);
  max-height: var(--0c3ef411);
}
.icon-vue--directional[data-v-5a43cff9] svg:dir(rtl) {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcIconSvgWrapper-D6qXQDNo.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-5a43cff9] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.icon-vue[data-v-5a43cff9] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: var(--default-clickable-area);\n  min-height: var(--default-clickable-area);\n  opacity: 1;\n}\n.icon-vue.icon-vue--inline[data-v-5a43cff9] {\n  display: inline-flex !important;\n  min-width: fit-content;\n  min-height: fit-content;\n  vertical-align: text-bottom;\n}\n.icon-vue span[data-v-5a43cff9] {\n  line-height: 0;\n}\n.icon-vue[data-v-5a43cff9] svg {\n  fill: currentColor;\n  width: var(--0c3ef411);\n  height: var(--0c3ef411);\n  max-width: var(--0c3ef411);\n  max-height: var(--0c3ef411);\n}\n.icon-vue--directional[data-v-5a43cff9] svg:dir(rtl) {\n  transform: scaleX(-1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
